import TypeUtil from "./typeUtil";

export default class ObjectUtil {
  static isEmpty(value: any) {
    return value === null || value === undefined || value === '' || (Array.isArray(value) && value.length === 0) || (!(value instanceof Date) && typeof value === 'object' && Object.keys(value).length === 0);
  }

  static isNotEmpty(value: any) {
    return !this.isEmpty(value);
  }

  static findIdKeyNameFromMap(obj: any) {
    return (Object.keys(obj)).find(key => key.endsWith('Id'));
  }

 static bytesToMegabytes(bytes: number) {
    if (bytes >= 1000 * 1024) {
      return (bytes / (1024 * 1024)).toFixed(2) + ' MB';
    }
    return (bytes / 1024).toFixed(2) + ' KB';
  }

  static findIdKeyValueFromMap(obj: any) {
    const keyName = this.findIdKeyNameFromMap(obj);
    return keyName ? obj[keyName] : '';
  }

  static equals(obj1: any, obj2: any, field: any) {
      if (field && obj1 && typeof obj1 === 'object' && obj2 && typeof obj2 === 'object') return this.resolveFieldData(obj1, field) === this.resolveFieldData(obj2, field);
      else return this.deepEquals(obj1, obj2);
  }

  static deepEquals(a: any, b: any) {
    if (a === b) return true;

    if (a && b && typeof a == 'object' && typeof b == 'object') {
      let arrA = Array.isArray(a),
        arrB = Array.isArray(b),
        i,
        length,
        key;

      if (arrA && arrB) {
        length = a.length;
        if (length !== b.length) return false;
        for (i = length; i-- !== 0;) if (!this.deepEquals(a[i], b[i])) return false;

        return true;
      }

      if (arrA !== arrB) return false;

      let dateA = a instanceof Date,
        dateB = b instanceof Date;

      if (dateA !== dateB) return false;
      if (dateA && dateB) return a.getTime() === b.getTime();

      let regexpA = a instanceof RegExp,
        regexpB = b instanceof RegExp;

      if (regexpA !== regexpB) return false;
      if (regexpA && regexpB) return a.toString() === b.toString();

      let keys = Object.keys(a);

      length = keys.length;

      if (length !== Object.keys(b).length) return false;

      for (i = length; i-- !== 0;) if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

      for (i = length; i-- !== 0;) {
        key = keys[i];
        if (!this.deepEquals(a[key], b[key])) return false;
      }

      return true;
    }

    return a !== a && b !== b;
  }

  static resolveFieldData(data: any, field: any) {
    if (!data || !field) {
      return null;
    }

    try {
      const value = data[field];

      if (this.isNotEmpty(value)) return value;
    } catch {
    }

    if (Object.keys(data).length) {
      if(TypeUtil.isFunction(field)) {
        return field(data);
      } else if (this.isNotEmpty(data[field])) {
        return data[field];
      } else if (field.indexOf('.') === -1) {
        return data[field];
      } else {
        let fields = field.split('.');
        let value = data;

        for (let i = 0, len = fields.length; i < len; ++i) {
          if (value == null) {
            return null;
          }

          value = value[fields[i]];
        }

        return value;
      }
    }

    return null;
  }

  static groupBy<T, K extends keyof any>(arr: T[], key: (i: T) => K) {
    return arr.reduce((groups, item) => {
      (groups[key(item)] ||= []).push(item);
      return groups;
    }, {} as Record<K, T[]>);
  }

  /**
   * dot 표기법을 지원하는 객체 값 설정
   * 예: setNestedValue(obj, 'invoicerParty.corpNum', '1234567890')
   * dot이 없으면 1depth로 동작
   */
  static setNestedValue<T extends Record<string, any>>(obj: T, field: string, value: any): T {
    const result = { ...obj };

    if (field.indexOf('.') === -1) {
      (result as any)[field] = value;
      return result;
    }

    const keys = field.split('.');
    let target: any = result;

    for (let i = 0; i < keys.length - 1; i++) {
      target[keys[i]] = { ...target[keys[i]] };
      target = target[keys[i]];
    }

    target[keys[keys.length - 1]] = value;
    return result;
  }

  static divisionArray<T>(array: T[], n: number): T[][] {
    const length = array.length;
    const divide = Math.floor(length / n) + (Math.floor(length % n) > 0 ? 1 : 0);
    const newArray: T[][] = [];

    for (let i = 0; i <= divide; i++) {
      newArray.push(array.splice(0, n));
    }

    return newArray;
  }
}